/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Sales
 *
 * 2 = Aftersales
 *
 * 3 = DocumentsLogs
 *
 * 4 = Parts
 *
 * 5 = Templates
 */
export enum DocumentsLogsCategoryEnum {
  Sales = 1,
  Aftersales = 2,
  DocumentsLogs = 3,
  Parts = 4,
  Templates = 5,
}
